import { Link } from 'react-router-dom';

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="relative z-10 border-t border-ink-400/50 bg-ink-700/75 backdrop-blur-md mt-20 shadow-[inset_0_1px_0_rgba(255,255,255,0.06)]">
      <div className="container-app py-14 grid gap-12 lg:grid-cols-5">
        <div className="lg:col-span-2">
          {/* El PNG del logo tiene el símbolo dentro de un lienzo con mucho margen vacío
              (ocupa el 44% del alto), así que se amplía con object-cover y scale, igual
              que en el Header, en vez de mostrar el lienzo entero. */}
          <div className="flex items-center gap-0 mb-4">
            <span aria-hidden className="inline-flex h-11 w-11 items-center justify-center shrink-0 -mr-1.5">
              <img
                src="/Vapsilver_logo.png"
                alt=""
                className="h-full w-full object-cover scale-[3.25] origin-center"
                loading="lazy"
              />
            </span>
            <span className="text-2xl font-semibold tracking-tighter">
              ap<span className="text-vapor-400">Silver</span>
            </span>
          </div>
          <p className="text-sm text-bone-300 max-w-sm leading-relaxed">
            Tienda online española de productos de vapeo conformes a la
            Ley 28/2005 y al Real Decreto 579/2017. Toda la información
            sanitaria, ingredientes y advertencias detalladas en cada ficha.
          </p>
          {/* Oculto hasta tener los datos definitivos de la sociedad. Para volver a
              mostrarlo, basta descomentar y sustituir el CIF y la dirección reales.
              Los datos identificativos que exige la LSSI siguen accesibles en el
              Aviso legal. */}
          {/*
          <p className="text-xs text-bone-400 mt-4">
            VapSilver · CIF 47447010B · Calle Herradores 3, 02002 Albacete
          </p>
          */}
        </div>

        <FooterCol title="Tienda" links={[
          { to: '/tienda', label: 'Catálogo completo' },
          { to: '/tienda/dispositivos', label: 'Dispositivos' },
          { to: '/tienda/liquidos', label: 'Líquidos' },
          { to: '/tienda/desechables', label: 'Pods desechables' },
        ]} />

        <FooterCol title="Ayuda" links={[
          { to: '/contacto', label: 'Contacto' },
          { to: '/politica-devoluciones', label: 'Devoluciones' },
          { to: '/terminos-condiciones', label: 'Envíos y condiciones' },
        ]} />

        <FooterCol title="Legal" links={[
          { to: '/aviso-legal', label: 'Aviso legal' },
          { to: '/politica-privacidad', label: 'Política de privacidad' },
          { to: '/politica-cookies', label: 'Política de cookies' },
          { to: '/terminos-condiciones', label: 'Términos y condiciones' },
        ]} />
      </div>

      <div className="border-t border-ink-500/50">
        <div className="container-app py-5 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-bone-400">
          <p>© {year} VapSilver — Todos los derechos reservados.</p>

          {/* El logotipo de Albai es azul marino sobre transparencia, así que necesita
              una placa clara detrás: sobre el fondo del footer sería invisible. */}
          <a
            href="https://albai.es"
            target="_blank"
            rel="noopener noreferrer"
            className="group inline-flex items-center gap-3 rounded-md focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-vapor-400"
          >
            <span className="text-[10px] uppercase tracking-[0.22em] transition-colors group-hover:text-bone-200">
              powered by
            </span>
            <span className="rounded-md bg-bone-50 px-4 py-2 transition-transform group-hover:scale-[1.03]">
              <img
                src="/images/albai-logo.png"
                alt="Albai"
                className="h-7 w-auto"
                loading="lazy"
                width="1080"
                height="360"
              />
            </span>
          </a>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, links }: { title: string; links: { to: string; label: string }[] }) {
  return (
    <div>
      <h3 className="text-xs uppercase tracking-widest text-bone-400 mb-3">{title}</h3>
      <ul className="space-y-2">
        {links.map((l) => (
          <li key={l.to}>
            <Link to={l.to} className="text-sm text-bone-200 hover:text-vapor-400">{l.label}</Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
